import { VariantType } from '../babylonjs/type/backendType'
import { IModel } from '../babylonjs/type/modelType'
import { colorsLibSet1, colorsLibSet2 } from './colors'

export const models: IModel[] = [
  {
    id: 'chairModular', // unique id
    title: 'Chair Pong', // title for UI
    source:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/models/chair-modular/Chair Modular Custom.gltf',
    transform: {
      rotate: {
        y: 45,
      },
    },
    meshes: [
      {
        id: '6829a946-0a46-4149-882f-e5f3f9826264',
        meshGroup: 'E1',
        title: 'Chair', // initial use meshGroup by default,
        variants: [],
        canHideMesh: false,
      },
      {
        id: '1923fcb3-1e58-4b89-9b57-b562a78920bd',
        meshGroup: 'E2',
        title: 'Cushion', // initial use meshGroup by default,
        variants: [],
        canHideMesh: false,
      },
      {
        id: '88eb80a1-b243-4ce4-8a9a-54c4bea5c52e',
        meshGroup: 'E3',
        title: 'Leg', // initial use meshGroup by default,
        variants: [],
        canHideMesh: false,
      },
    ],
    preview:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/models/chair-modular/preview.jpg',
    dimensions: {
      unit: 'CM',
      d: 25,
      h: 35,
      w: 40,
    },
  },
]
